import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const Loader = setTimeout(() => {
      setLoading(true);
    }, 1000); // 1 seconds

    return () => clearTimeout(Loader);
  }, []);

  return (
    <>
      {loading ? ( // Show UI after 5s
        <section
          style={{ backgroundColor: "#ccc", padding: "0", height: "50vh" }}
        >
          <div className="container mx-auto text-center pt-100 pb-5">
            <h1 className="text-center text-dark mt-100 mb-5">
              This Page Not Found
            </h1>
            <Link to="/" className="btn btn-danger mb-5">
              Home Page
            </Link>
          </div>
        </section>
      ) : null}{" "}
      {/* Initially show nothing */}
    </>
  );
};

export default NotFound;
